export function ZeroSection() {
  return (
    <section className="sec deep zero" id="zeroSec">
      <div className="eyebrow">
        <span className="bar" /> Our promise <span className="bar" />
      </div>
      <h2>
        <span className="z-big">We add</span> <span className="strike">$0</span> <span className="z-big">Zero.</span>
      </h2>
      <p className="lede">
        No padding on flights. No hidden hotel spread. No endless click-to-funnel. Our revenue is a flat membership and a 4% transaction fee, never a markup.
      </p>
      <div className="zero-stats">
        <div className="zero-stat"><div className="n">$0</div><div className="l">Member markup</div></div>
        <div className="zero-stat"><div className="n">From $2.49/mo</div><div className="l">Membership · Annual billing · Basic tier</div></div>
      </div>
    </section>
  );
}
